import React from "react";
import { parsal_img } from "../../../assets/mediaCall";

const ChooseParsal = () => {
  const features = [
    {
      title: "Reliability",
      description: "Count on us for timely, dependable shipments every time.",
      images: parsal_img.frame10,
    },
    {
      title: "Real-Time Tracking",
      description: "Track your shipment live from pick-up to delivery.",
      images: parsal_img.frame11,
    },
    {
      title: "Cost-Efficient Solutions",
      description:
        "Get budget-friendly, optimized logistics without sacrificing quality.",
      images: parsal_img.frame12,
    },
    {
      title: "Safety First",
      description: "We handle every package with top-notch safety standards.",
      images: parsal_img.frame13,
    },
    {
      title: "24/7 Support",
      description:
        "Our expert team is here for you anytime you need assistance.",
      images: parsal_img.frame14,
    },
  ];

  return (
    <div className="bg-[#f8f8f8]">
      <div className="w-[85vw] mlg:w-[90vw] smp:w-[96vw] mx-auto inter">
        <div className="flex flex-col items-center py-20 mlg:py-16">
          {/* Title Section */}
          <h3 className="font-semibold inter sm:text-[14px] text-[#6D6D6D] text-center">
            WHY CHOOSE PARSAL LOGISTIC
          </h3>
          <h1 className="font-extrabold inter text-center t text-[30px] sm:text-2xl text-[#000000] leading-[36px] mt-2">
            Choose Parsal for a Super
            <br /> Shipping Experience
          </h1>

          {/* Feature Cards */}
          <div className="grid grid-cols-3 lg:grid-cols-2 sm:grid-cols-1 gap-10 lg:gap-6 mt-10 mx-3">
            {features.map((feature, index) => (
              <div
                key={index}
                // style={{ boxShadow: "0px 38px 60px 0px #0000000F" }}
                className={`bg-white max-w-[384px] h-[188px] rounded-xl p-6 flex flex-col items-center lg:flex lg:flex-col lg:items-center  text-center ${
                  index >= 3 ? "hidden" : ""
                }`}
              >
                <div className="w-12 h-12 flex items-center justify-center mb-4 lg:mx-auto">
                  <img
                    src={feature.images}
                    alt="images"
                    className="h-full w-full object-fill"
                  />
                </div>
                <h4 className="text-lg font-semibold text-gray-900">
                  {feature.title}
                </h4>
                <p className="text-sm text-gray-600 mt-2 w-[80%] xxl:w-[100%]">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          {/* Centering last two items */}
          <div className="flex justify-center gap-6 mt-10 lg:hidden">
            <div
              // style={{ boxShadow: "0px 38px 60px 0px #0000000F" }}
              className="bg-white rounded-xl  p-6 flex flex-col items-center text-center  max-w-[384px]"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-4 lg:mx-auto">
                <img
                  src={features[3].images}
                  alt="images"
                  className="h-full w-full object-fill"
                />
              </div>
              <h4 className="text-lg font-semibold text-gray-900">
                {features[3].title}
              </h4>
              <p className="text-sm text-gray-600 mt-2 w-[70%]">
                {features[3].description}
              </p>
            </div>
            <div
              // style={{ boxShadow: "0px 38px 60px 0px #0000000F" }}
              className="bg-white rounded-xl  p-6 flex flex-col items-center text-center ml-4  max-w-[384px]"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-4 lg:mx-auto">
                <img
                  src={features[4].images}
                  alt="images"
                  className="h-full w-full object-fill"
                />
              </div>
              <h4 className="text-lg font-semibold text-gray-900">
                {features[4].title}
              </h4>
              <p className="text-sm text-gray-600 mt-2">
                {features[4].description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseParsal;

// import React from "react";
//
// const ChooseParsal = () => {
//   const features = [
//     {
//       title: "Reliability",
//       description: "Count on us for timely, dependable shipments every time.",
//       color: "bg-purple-200",
//     },
//     {
//       title: "Real-Time Tracking",
//       description: "Track your shipment live from pick-up to delivery.",
//       color: "bg-green-200",
//     },
//     {
//       title: "Cost-Efficient Solutions",
//       description: "Get budget-friendly, optimized logistics without sacrificing quality.",
//       color: "bg-yellow-200",
//     },
//     {
//       title: "Safety First",
//       description: "We handle every package with top-notch safety standards.",
//       color: "bg-red-200",
//     },
//     {
//       title: "24/7 Support",
//       description: "Our expert team is here for you anytime you need assistance.",
//       color: "bg-purple-200",
//     },
//   ];
//
//   return (
//     <div className="w-[85vw] mlg:w-[90vw] smp:w-[96vw] mx-auto">
//       <div className="flex flex-col items-center py-12 bg-[#FFFFFF]">
//         {/* Title Section */}
//         <h3 className="font-semibold inter text-[14px] text-[#6D6D6D] text-center">
//           WHY CHOOSE PARSAL LOGISTIC
//         </h3>
//         <h1 className="font-extrabold inter text-center text-[38px] sm:text-[23px] xs:text-[20px] text-[#000000] leading-[45.99px] mt-2">
//           Choose Parsal for a Super<br /> Shipping Experience
//         </h1>
//
//         {/* Feature Cards */}
//         <div className="grid grid-cols-3 lg:grid-cols-1  gap-6 mt-10">
//           {features.map((feature, index) => (
//             <div
//               key={index}
//               className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center"
//             >
//               <div
//                 className={`w-10 h-10 ${feature.color} rounded-full mb-4 flex items-center justify-center`}
//               ></div>
//               <h4 className="text-lg font-semibold text-gray-900">
//                 {feature.title}
//               </h4>
//               <p className="text-sm text-gray-600 mt-2">{feature.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };
//
// export default ChooseParsal;
